var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.4175 8.97876 4.8736-3.72685c1.3522-1.03409 3.2296-1.03409 4.5819 0l4.9667 3.79808a8.7264 8.7264 0 0 0 4.7205 1.77521l2.8732.1916c1.7026.1135 3.2175 1.1209 3.9806 2.6471.2749.5499.418 1.1561.418 1.7708v6.5438c0 4.8523-1.0901 9.6426-3.1899 14.0171a29.1523 29.1523 0 0 1-9.9351 11.5232l-4.0546 2.7458c-1.2549.8499-2.8966.8659-4.1679.0409l-4.0314-2.6164a28.21609 28.21609 0 0 1-10.466-12.305 31.35088 31.35088 0 0 1-2.65507-12.6265v-6.48c0-1.1486.40268-2.2608 1.13797-3.1432 1.0306-1.2367 2.5176-2.0041 4.1227-2.1275l1.8962-.1459a9.28567 9.28567 0 0 0 4.9286-1.88224Z",
    stroke: "#fff",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.9084 33.6194-4.8889-4.8889c-.3797-.3797-.3797-.9953 0-1.375.3797-.3797.9953-.3797 1.375 0l4.125 4.125 9.625-9.625c.3797-.3797.9953-.3797 1.375 0 .3797.3797.3797.9953 0 1.375L27.1306 33.6194c-.3375.3375-.8847.3375-1.2222 0Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.19e17d9b2831d485889694e798dc7c71.svg";
export { ForwardRef as ReactComponent };